import Button from '../../../../components/form-control/Button';
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Formik } from 'formik';
import Input from '../../../../components/form-control/Input';
import * as Yup from 'yup';
import { useState } from 'react';
import { createNewProduct } from '../../../../api/requests';
import { showToast } from '../../../../utils/miscFunctions';
import TextArea from '../../../../components/form-control/TextArea';
import SelectMenu from '../../../../components/form-control/SelectMenu';
import FileUpload from '../../../../components/elements/FileUpload/FileUpload';
import useImage from '../../../../hooks/imageHook';

const AddProduct = ({ onProceed, onClose }: { onProceed: () => void; onClose: () => void }) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [productIconFile, setProductIconFile] = useState<File | null>();
  const { productIconUpload } = useImage();

  return (
    <div className="w-full">

      <div className="p-5">
        <Formik
          initialValues={{
            active: '',
            name: '',
            description: ''
          }}
          validateOnChange={false}
          validateOnBlur
          validationSchema={Yup.object({
            name: Yup.string().trim().required('Product name is required.'),
            active: Yup.string().trim().required('Product status is required.'),
            description: Yup.string().trim().required('Product description is required.')
          })}
          onSubmit={(values) => {
            setSubmitting(true);
            const payload = {
              ...values,
              active: values.active === 'Active' ? true : false
            };

            createNewProduct(payload)
              .then((response: any) => {
                if (response) {
                  if (productIconFile) {
                    productIconUpload(response.id, productIconFile).then(() => {
                      showToast.success(response.message);
                    });
                  }

                  showToast.success(response.message ?? 'Product created successfully');
                  onProceed();
                }   
              })
              .catch((error: any) => {
                showToast.error(error?.description);
              })
              .finally(() => setSubmitting(false));
          }}>
          {({ values, errors, handleSubmit, handleChange, handleBlur, setFieldValue, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <div className="grid grid-cols-1  justify-center gap-5">
                  <Input
                    name="name"
                    label="Name"
                    value={values.name}
                    type="text"
                    wrapperClasses=""
                    required
                    error={touched.name ? errors.name : undefined}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.name ? errors.name : undefined}
                  />

                  <SelectMenu
                    label="Status"
                    name="active"
                    placeholder="Select product status"
                    onChange={(value: string) => {
                      setFieldValue('active', value);
                    }}
                    list={['Active', 'Inactive']}
                    listSelectedValue={values.active}
                    onBlur={handleBlur}
                    required
                    helperText={touched.active ? errors.active : undefined}
                    error={touched.active ? errors.active : undefined}
                  />
                  <FileUpload
                    onFileLoad={(images: any) => {
                      if(images && images[0]){
                            
                        setProductIconFile(images[0]);
                      }
                    }}
                    showFileMax={false}
                    onFileDeleted={() => {
                      setProductIconFile(null);
                    }}
                    title="Product Icon"
                    label="Icon"
                    maxHeight={200}
                    maxWidth={200}
                    imageContainerHeight={'200px'}
                    imageAlt={'Product Icon'}
                  />

                  <TextArea
                    name="description"
                    label="Description"
                    value={values.description}
                    required
                    error={touched.description ? errors.description : undefined}
                    onChange={handleChange}
                    onBlur={handleChange}
                    helperText={touched.description ? errors.description : undefined}
                  />
                </div>
              </div>

             <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
              fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddProduct;
